/* Comparatif Monsieur Carpe : apparitions, progression, onglets, FAQ, tri et filtres.
   Le tri et les filtres sont pilotes par les attributs data- poses par le Liquid,
   donc le meme script sert pour un comparatif de bateaux, de detecteurs ou de tentes.
   Regles de filtre : "tous" | "cle:<:valeur" | "cle:>=:valeur" | "cle1+cle2:oui" */
(function(){
  function init(root){
    if(!root || root.dataset.mcReady) return;
    root.dataset.mcReady = '1';

    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('mc-in'); io.unobserve(e.target); } });
    }, {threshold:.08});
    root.querySelectorAll('.mc-rv').forEach(function(el){ io.observe(el); });

    var prog = root.querySelector('.mc-prog i');
    if(prog){
      var onScroll = function(){
        var h = document.documentElement, p = h.scrollHeight - h.clientHeight;
        prog.style.width = (p > 0 ? Math.round(h.scrollTop / p * 100) : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    }

    root.querySelectorAll('[data-mc-tab]').forEach(function(b){
      b.addEventListener('click', function(){
        var k = b.getAttribute('data-mc-tab');
        root.querySelectorAll('[data-mc-tab]').forEach(function(x){ x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        root.querySelectorAll('[data-mc-pane]').forEach(function(p){ p.classList.toggle('mc-hide', p.getAttribute('data-mc-pane') !== k); });
      });
    });

    root.querySelectorAll('[data-mc-q]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var panel = btn.parentNode.querySelector('.mc-ans');
        var sign = btn.querySelector('[data-mc-sign]');
        var open = panel.classList.toggle('mc-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(sign) sign.textContent = open ? '–' : '+';
      });
    });

    var bodies = root.querySelectorAll('[data-mc-rows]');
    if(!bodies.length) return;

    var first = root.querySelector('[data-mc-sort]');
    var state = {sort: first ? first.getAttribute('data-mc-sort') : 'prix', filter: 'tous'};
    var count = root.querySelector('[data-mc-count]');
    var label = root.querySelector('[data-mc-sortlabel]');

    function num(el, k){
      var v = el.getAttribute('data-' + k);
      if(v === '' || v === null) return null;
      var n = parseFloat(v);
      return isNaN(n) ? null : n;
    }
    function garde(r){
      var f = state.filter;
      if(!f || f === 'tous') return true;
      var parts = f.split(':');
      var cles = parts[0].split('+');
      if(parts[1] === 'oui' || parts.length === 2){
        return cles.every(function(c){ return r.getAttribute('data-' + c) === 'oui'; });
      }
      var op = parts[1], seuil = parseFloat(parts[2]), v = num(r, cles[0]);
      if(v === null) return false;
      if(op === '<') return v < seuil;
      if(op === '<=') return v <= seuil;
      if(op === '>') return v > seuil;
      if(op === '>=') return v >= seuil;
      return true;
    }
    function apply(){
      var shown = 0;
      var asc = (state.sort === 'prix' || state.sort === 'poids');
      bodies.forEach(function(body){
        var rows = Array.prototype.slice.call(body.querySelectorAll('[data-mc-item]'));
        rows.sort(function(a,b){
          var av = num(a, state.sort), bv = num(b, state.sort);
          if(av === null) av = asc ? Infinity : -1;
          if(bv === null) bv = asc ? Infinity : -1;
          return asc ? av - bv : bv - av;
        });
        var rank = 0;
        rows.forEach(function(r){
          var ok = garde(r);
          r.classList.toggle('mc-hide', !ok);
          if(ok){ rank++; var n = r.querySelector('[data-mc-rank]'); if(n) n.textContent = rank; }
          body.appendChild(r);
        });
        shown = rank;
      });
      if(count){
        var un = count.getAttribute('data-mc-un') || 'modèle', plusieurs = count.getAttribute('data-mc-plusieurs') || 'modèles';
        count.textContent = shown + ' ' + (shown > 1 ? plusieurs : un);
      }
      if(label){
        var btn = root.querySelector('[data-mc-sort="' + state.sort + '"]');
        label.textContent = btn ? btn.textContent.replace('▾','').trim().toLowerCase() : state.sort;
      }
    }
    root.querySelectorAll('[data-mc-sort]').forEach(function(b){
      b.addEventListener('click', function(){
        state.sort = b.getAttribute('data-mc-sort');
        root.querySelectorAll('[data-mc-sort]').forEach(function(x){ x.removeAttribute('aria-sort'); });
        b.setAttribute('aria-sort', 'descending');
        apply();
      });
    });
    root.querySelectorAll('[data-mc-filter]').forEach(function(b){
      b.addEventListener('click', function(){
        state.filter = b.getAttribute('data-mc-filter');
        root.querySelectorAll('[data-mc-filter]').forEach(function(x){ x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  }
  function boot(){ document.querySelectorAll('[data-mc-comparatif]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
